import React from 'react';
import PropTypes from 'prop-types';

import {cn} from 'spa/css';

const RadioGroup = ({
  className, disabled, hasBottomBorder, includeDefault, isBlockOptions, isRightRadio, items, name, selected, ...rest
}) => {
  const defaultVal = {
    label: 'All',
    value: '',
  };

  if (includeDefault && items[0] && items[0].label !== defaultVal.label) {
    items.unshift(defaultVal);
  }

  return (
    <div
      className={cn(
        'form-radio',
        className,
      )}
      {...rest}>
      {items.reduce(
        (array, item, index) => (
          array.concat(
            <input
              key={`item-${index}`}
              id={`${name}-${index}`}
              type="radio"
              name={name}
              value={item.value}
              checked={selected === item.label.toLowerCase() || selected === item.value}
              disabled={disabled}
              readOnly
            />,
            <label
              key={`label-${index}`}
              htmlFor={`${name}-${index}`}
              className={cn(
                'form-radio-label',
                hasBottomBorder && 'form-radio-label--block-border',
                isBlockOptions && 'form-radio-label--block-options',
                isRightRadio && 'form-radio-label--right-radio',
                item.icon && 'form-radio-label--with-icon',
                selected === item.label.toLowerCase() || selected === item.value ? 'form-radio-label--active' : '',
              )}
            >
              {item.icon && (
                <div className="form-radio-label__icon-container">
                  <img
                    alt=""
                    className="form-radio-label__icon"
                    src={item.icon} />
                </div>
              )}
              {item.label}
              {item.extraLabel && (
                <span className="form-radio-label__extra-label">
                  {item.extraLabel}
                </span>
              )}
            </label>,
          )),
        [],
      )}
    </div>
  );
};
RadioGroup.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hasBottomBorder: PropTypes.bool,
  includeDefault: PropTypes.bool,
  isBlockOptions: PropTypes.bool,
  isRightRadio: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    extraLabel: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.node.isRequired,
    value: PropTypes.any.isRequired,
  })).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  selected: PropTypes.any,
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./spa/Components/Form/RadioGroup.jsx